import React, { useEffect, useState } from 'react'
import qrCode from './../../images/qr_code.png'
import { BASE } from '../../basedata/constants'

import './ErrorsHandlers.sass'

const MobileHandler = () => {

  const makeid = (length: any) => {
    let result = ''
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  const verifyBiometry = (token: any) => {


    fetch(`${BASE.api.base_url}${BASE.api.validate_face}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: BASE.api.token
      },
      body: JSON.stringify({
        "token": token
      })
    })
      .then((resg) => resg.json())
      .then((response) => {



        if (response.biometry) {
          if (response.callbackUrl) {
            // window.location.href = `${response.callbackUrl}`

          } else {
            // window.location.reload()
          }
        } else {
          setTimeout(() => {

            // verifyBiometry(token)
          }, 5000);
        }


      })
      .catch((error) => {
        return false
      })
  }


  const [currentUrl, setCurrentUrl] = React.useState(window.location.origin+window.location.pathname)
  const [userToken, setUserToken] = React.useState('xxxxxx')
  const [originCompany, setOriginCompany] = React.useState('')

  React.useEffect(() => {
    if (window.sessionStorage.getItem('token')) {
      setUserToken(window.sessionStorage.getItem('token') + '')
      setOriginCompany(window.sessionStorage.getItem('originCompany') + '')
    }
  }, [])

  React.useEffect(() => {
    verifyBiometry(window.sessionStorage.getItem('token'))
  }, [])




  return (
    <>
      <h1>
        <span>{`Let's`} </span>do it?!
      </h1>
      <hr />
      <p>
      For a better experience, we ask that you access from your mobile device.</p>
      <p>Scan this QR CODE with your mobile or access the link below:</p>
      <img
        src={
          `https://api.qrserver.com/v1/create-qr-code/?size=300x300&bgcolor=ffffff&data=${currentUrl}?token=` + userToken + `	%26orc=` + originCompany}
        className="qr-code"
        alt="Onboarding"
      />
      <a
        className="qr-link"
        href={`${currentUrl}?token=${userToken}&orc=` + originCompany}
      >
        {`${currentUrl}?token=${userToken}&orc=` + originCompany}
      </a>
    </>
  )
}

export default MobileHandler
